import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function getConstant(params = {}) {
  return request({
    url: ENDPOINT.CONSTANT,
    method: 'get',
    params
  })
}
